import { ErrorMessage } from 'formik';

type FormErrorMessageProps = {
    field: string;
};

export default function FormErrorMessage({ field }: FormErrorMessageProps) {
    return <ErrorMessage name={field}>{(msg) => <p className='error'>{msg}</p>}</ErrorMessage>;
}
